import { BudgetableUserReadModel, UserManagementApi } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { UserManagementApiService } from "../ApiServices/UserManagementApiService";
import GenericService from "../GenericService";

export class UserManagementService extends GenericService<UserManagementApi, UserManagementApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, UserManagementApi, UserManagementApiService);
  }

  public async getAllUserData(): Promise<BudgetableUserReadModel[]> {
    return this.apiService.userManagementGetAllUserData();
  }

  public async updateSetDisplayBudget(show: boolean): Promise<void> {
    return this.apiService.userManagementSetDisplayBudgetPatch({ value: show });
  }
}
